import { create } from 'zustand';

/**
 * Tracks when the backend session will idle-expire, derived from the
 * `Session-Expires-In` response header (seconds remaining) that the backend
 * returns on every authenticated response. The axios response interceptor
 * updates this on each call, so any activity pushes `expiresAt` forward.
 *
 * Intentionally NOT persisted — it's derived live from responses. On reload it
 * starts null and is repopulated by the first authenticated response.
 */
interface SessionExpiryState {
  /** Epoch ms when the session idle-expires; null when unknown / logged out. */
  expiresAt: number | null;
  /** Set from the raw `Session-Expires-In` header value (seconds). */
  setFromHeader: (secondsRaw: string | number | undefined | null) => void;
  clear: () => void;
}

export const useSessionExpiryStore = create<SessionExpiryState>((set) => ({
  expiresAt: null,
  setFromHeader: (secondsRaw) => {
    if (secondsRaw == null) return;
    const seconds = Number(secondsRaw);
    if (!Number.isFinite(seconds) || seconds <= 0) return;
    set({ expiresAt: Date.now() + seconds * 1000 });
  },
  clear: () => set({ expiresAt: null }),
}));

export default useSessionExpiryStore;
